import { configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PURGE, PERSIST, REGISTER, REHYDRATE, persistStore } from 'redux-persist';

import { chatApi } from 'src/pages/chat/slice/chatApi';
import { authApi } from 'src/pages/auth/slice/authApi';
import { ticketApi } from 'src/pages/tickets/slice/ticketApi';
import { tenantApi } from 'src/pages/tenants/slice/tenantsApi';
import { channelApi } from 'src/pages/channel/slice/channelApi';
import { settingApi } from 'src/pages/setting/slice/settingApi';
import { accountAPi } from 'src/pages/accounts/slice/accountsApi';
import { contactsApi } from 'src/pages/contacts/slice/contactsApi';
import { campaignApi } from 'src/pages/campaign/slice/campaignApi';
import { dashboardApi } from 'src/pages/dashborad/slice/dashboardApi';

import persistedReducer from './rootReducer';

const middleware = [
  authApi.middleware,
  contactsApi.middleware,
  accountAPi.middleware,
  authApi.middleware,
  settingApi.middleware,
  chatApi.middleware,
  channelApi.middleware,
  dashboardApi.middleware,
  tenantApi.middleware,
  campaignApi.middleware,
  ticketApi.middleware,
  // logger
];

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Persistor to manage rehydration
export const persistor = persistStore(store);
